import { render, staticRenderFns } from "./data-progress.vue?vue&type=template&id=5585ab1a&scoped=true&"
import script from "./data-progress.vue?vue&type=script&lang=js&"
export * from "./data-progress.vue?vue&type=script&lang=js&"
import style0 from "./data-progress.vue?vue&type=style&index=0&id=5585ab1a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5585ab1a",
  null
  
)

export default component.exports